import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import userReducer from "../reducers/userReducer";
import { appApi } from "./appSlice";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { profileApi } from "./profileSlice";
import { chatApi } from "./chatsSlice";
import { jobsApi } from "./jobsSlice";
import { commonApi } from "./commonSlice";
import { TestCenterApi } from "./testCenterSlice";
import commonReducer from "../reducers/commonReducer";

export const rootReducers = combineReducers({
  // STORE
  user: userReducer,
  common: commonReducer,

  // API
  [appApi.reducerPath]: appApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [jobsApi.reducerPath]: jobsApi.reducer,
  [commonApi.reducerPath]: commonApi.reducer,
  [TestCenterApi.reducerPath]: TestCenterApi.reducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["user"],
};

const reducersWithPersist = persistReducer(persistConfig, rootReducers);
export const store = configureStore({
  reducer: reducersWithPersist,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      appApi.middleware,
      profileApi.middleware,
      chatApi.middleware,
      jobsApi.middleware,
      commonApi.middleware,
      TestCenterApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
